var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { "padding-top": "0.98rem" } },
    [
      _c("topbar", { attrs: { text: "电子书" } }),
      _vm._v(" "),
      _vm.emptyStatus
        ? _c("div", { staticClass: "emptyBox" }, [
            _c("div", { staticClass: "emptyImg" }),
            _vm._v(" "),
            _c("div", { staticClass: "emptyName" }, [
              _vm._v("目前还没有内容哦~")
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "list" },
        _vm._l(_vm.list, function(item, index) {
          return _c(
            "div",
            {
              key: index,
              staticClass: "item",
              on: {
                click: function($event) {
                  _vm.to(item.bookId)
                }
              }
            },
            [
              _c("img", {
                staticClass: "itemIcon",
                attrs: { src: _vm.EnvUrl + item.bookPic, alt: "" }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "itemRight" }, [
                _c("div", [
                  _c("div", { staticClass: "itemTitle" }, [
                    _vm._v(_vm._s(item.title))
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "itemTagline" }, [
                    _vm._v(_vm._s(item.tagline))
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "itemBottomBox" }, [
                  _c("div", { staticClass: "num" }, [
                    _vm._v(_vm._s(item.readCount) + "人学习")
                  ]),
                  _vm._v(" "),
                  item.payType == 1
                    ? _c("div", { staticClass: "btn active" }, [
                        _vm._v(
                          "\n            购买 ￥" +
                            _vm._s(item.bookPrice) +
                            "\n          "
                        )
                      ])
                    : _c("div", { staticClass: "btn" }, [_vm._v("免费")])
                ])
              ])
            ]
          )
        })
      ),
      _vm._v(" "),
      _c("no-more-data", { attrs: { noMoreData: _vm.noMoreData } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-71aa9a0e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71aa9a0e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/eBook.vue
// module id = null
// module chunks = 